<template>
  <div class="banner">
    <swiper :options="swiperOption" ref="mySwiper">
      <!-- slides -->
      <!--<swiper-slide>-->
        <!--<div class="caption">-->
          <!--<img src="../../assets/banner_desc.png" alt="">-->
        <!--</div>-->
        <!--<img src="../../assets/banner1.jpg" alt="" width="100%">-->
      <!--</swiper-slide>-->
      <swiper-slide>
        <img src="../../assets/banner1.jpg" alt="" width="100%">
      </swiper-slide>
      <swiper-slide>
        <img src="../../assets/banner2.jpg" alt="" width="100%">
      </swiper-slide>
      <swiper-slide>
        <img src="../../assets/banner3.jpg" alt="" width="100%">
      </swiper-slide>
      <swiper-slide>
        <img src="../../assets/banner4.jpg" alt="" width="100%">
      </swiper-slide>
      <!--<swiper-slide>-->
        <!--<div class="caption">-->
          <!--<img v-lazy="require('../../assets/banner_desc.png')" alt="">-->
        <!--</div>-->
        <!--<img v-lazy="require('../../assets/banner_01.jpg')" alt="" width="100%">-->
      <!--</swiper-slide>-->
      <!-- Optional controls -->
      <!--<div class="swiper-pagination"  slot="pagination"></div>-->
      <div class="swiper-button-prev" slot="button-prev"><i class="el-icon-arrow-left"></i></div>
      <div class="swiper-button-next" slot="button-next"><i class="el-icon-arrow-right"></i></div>
    </swiper>
  </div>
</template>

<script>
  import { swiper, swiperSlide } from 'vue-awesome-swiper'
  require('swiper/dist/css/swiper.css')
  export default {
    name: 'banner',
    components: {
      swiper,
      swiperSlide
    },
    data () {
      return {
        swiperOption: {
          autoplay: {
            disableOnInteraction: false, //用户操作后是否禁止自动循环
            delay: 3000 //自自动循环时间
          }, //可选选项，自动滑动
          speed: 2000, //切换速度，即slider自动滑动开始到结束的时间（单位ms）
          loop: true, //循环切换
          autoHeight: true,   //自动高度。设置为true时，wrapper和container会随着当前slide的高度而发生变化。
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          }
        }
      }
    }
  }
</script>
<style type="text/scss" rel="stylesheet/scss" lang="scss">
  .caption {
    max-width: 1200px;
    position: absolute;
    right: 0;
    left: 0;
    bottom: 5%;
    margin: 0 auto;
    text-align: left;
    z-index: 3;
    img{
      margin-left: 5%;
    }
  }
  .swiper-button-prev,
  .swiper-button-next {
    position: absolute;
    top: 50%;
    width: 44px!important;
    height: 44px;
    line-height: 44px;
    margin-top: -22px;
    z-index: 10;
    cursor: pointer;
    background-image: none!important;
    background-color: rgba(148,148,148,.8);
    color: #fff;
    font-size: 20px;
  }
  .swiper-button-prev:hover,
  .swiper-button-next:hover{
    opacity: .5;
  }
  @media screen and (max-width: 767px) {
    /*.banner {*/
      /*height: 500px;*/
    /*}*/
    .swiper-container-autoheight, .swiper-container-autoheight .swiper-slide {
      /*height: 500px;*/
      /*img{*/
        /*width: auto;*/
        /*height: 500px;*/
        /*margin: auto;*/
        /*overflow: hidden;*/
      /*}*/
      /*.caption{*/
        /*top: 70%;*/
        /*text-align: center;*/
        /*img{*/
          /*width: 90%;*/
          /*height: auto;*/
        /*}*/
      /*}*/
      .swiper-button-prev,
      .swiper-button-next {
        display: none;
      }
    }
  }
</style>
<style>
  .el-carousel__indicators{
    display: none;
  }
  .el-carousel__arrow{
    border-radius: 0;
  }
  .el-carousel__container{
    height: auto;
  }
  .el-icon-arrow-left,
  .el-icon-arrow-right{
    font-weight: bolder;
  }
  .swiper-button-prev{
    left: 10%;
  }
  .swiper-button-next{
    right: 10%;
  }
</style>



// WEBPACK FOOTER //
// src/components/home/Banner.vue